import { render, staticRenderFns } from "./widgetDecoratePieChart.vue?vue&type=template&id=d662b0b4&scoped=true&"
import script from "./widgetDecoratePieChart.vue?vue&type=script&lang=js&"
export * from "./widgetDecoratePieChart.vue?vue&type=script&lang=js&"
import style0 from "./widgetDecoratePieChart.vue?vue&type=style&index=0&id=d662b0b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d662b0b4",
  null
  
)

export default component.exports